module.exports = __webpack_public_path__ + "static/media/tongjirenyuan1.f40c4d10.png";